import { createApp } from "vue";
import App from "./App.vue";

export function createCardMessageApp() {
	const app = createApp(App);

	app.mount("#pick-a-card-message");
}
